import { Row } from "@tanstack/react-table";

export const calculateRowSize = <TRow>(
  index: number,
  rows: Row<TRow>[],
  rowHeight: number
): number => {
  const row = rows[index];
  if (!row) return rowHeight;

  const baseHeight = rowHeight;
  const expandedSubRowsHeight =
    row.getIsExpanded() && row.subRows.length > 0
      ? row.subRows.length * rowHeight
      : 0;

  return baseHeight + expandedSubRowsHeight;
};
